export function getVideoCoverUrl(videoItem) {
  const { coverUrl, customCoverUrl } = videoItem;
  return customCoverUrl || coverUrl;
}



// WEBPACK FOOTER //
// ./src/shared/ui-selectors/video/cover.js